import React from "react";
import {Tooltip} from 'react-bootstrap'
import { UpdateFamilyEPmbo, CreateSnapshotEPmbo, ProcessQueryEPmbo, CrudQueryEPmbo } from '../../variables/Config'

export const ID36 = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36)

export const ID10000000 = Math.floor(Math.random(Date()) * 10000000)
export const mboTooltip = (text) => <Tooltip className="mbo-tooltip" id="mbo-tooltip">
                            <span style={{direction: 'rtl'}}>{text}</span>
                      </Tooltip>

const incomeWeight = (val, period) => {
  const payPeriodW = {"חודשי" : 1, "דו חודשי" : 6,"רבעוני" : 4, "שנתי": 12, "חד פעמי": 0, "אחר": 0}
  // console.log('incomeWeight '+period+ " = "+payPeriodW)
  if (period === ""){
    alert("לא הוגדר ערך בשדה תדירות. לא ניתן לבצע חישוב נכון")
    return 0
  }
  if (period === "חד פעמי" || period === "אחר")
    return 0
  if (period === "חודשי")
    return val
  return (Math.round(val/payPeriodW[period]))
}
// periods - one time - ignore, quarter,year - take relative #
export const calcTotalIncome = (products,field,period) => {
  let i = 0, sum=0
  // console.log("calcTotalIncome", products.length)
  if (products === undefined || !Object.keys(products).length) return 0
  for (i = 0; i < products.length; i++)
    sum += products[i][field] === "" ? 0 : incomeWeight(parseInt(products[i][field]), products[i][period])
  return sum
}
// periods - one time - ignore, quarter,year - take relative #
// export const incomeType = ["משכורת","הכנסה מעסק","סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה",
// "נכות","השלמת הכנסה","הבטחת הכנסה","מס הכנסה שלילי- מענק עבודה","קצבת שארים","הכנסות מהון","תמיכה משפחה/חברים","מענק קרן הצדקה","אחר"]
// export incomeClass = [["משכורת","הכנסה מעסק"],["הכנסה מעסק","סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה"]]
export const calcTotalIncomeByClass = (products, field, byClass) => {
  let i = 0, sum=0
  //console.log("calcTotalIncomeByClass", pl)
  if (products === undefined || products.products === undefined) 
    return 0
  
  if (products.products.length < 1) 
    return 0

  let pl = products.products.length

  //console.log("calcIncome", products)
  let cfilter = []
  switch (byClass){
    case "work": cfilter = ["משכורת","הכנסה מעסק"]; break;
    case "capital": cfilter = ["הכנסות מהון"]; break;
    case "rights": cfilter = ["סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה", "נכות","השלמת הכנסה","הבטחת הכנסה","מס הכנסה שלילי- מענק עבודה","קצבת שארים", "תמיכה משפחה/חברים","מענק קרן הצדקה","אחר"]
         break
    default: 
      console.log("calcTotalIncomeByClass:  unexpected byClass value="+byClass)
      return -1
  } 
  let pp = products.products
  for (i = 0; i < pl; i++){
    let inType = pp[i]['income_type']
    let found = cfilter.filter(name => name.includes(inType))
    if (found.length){
      //alert('hello world')
      sum += pp[i][field] === "" ? 0 : incomeWeight(parseInt(pp[i][field]), pp[i]['income_frequency'])
    }
  }
  return sum
}
export const calcTotalIncomeByClass2 = (products, field, byClass) => {
  let i = 0, sum=0
  //console.log("calcTotalIncomeByClass", pl)
  if (products === undefined || products.length < 1) 
    return 0

  let pl = products.length

  //console.log("calcIncome", products)
  let cfilter = []
  switch (byClass){
    case "work": cfilter = ["משכורת","הכנסה מעסק"]; break;
    case "capital": cfilter = ["הכנסות מהון"]; break;
    case "rights": cfilter = ["סיוע בשכ''ד","קצבת ילדים","קצבת ילד נכה","מזונות","אבטלה", "נכות","השלמת הכנסה","הבטחת הכנסה","מס הכנסה שלילי- מענק עבודה","קצבת שארים", "תמיכה משפחה/חברים","מענק קרן הצדקה","אחר"]
         break
    default: 
      console.log("calcTotalIncomeByClass:  unexpected byClass value="+byClass)
      return -1
  } 
  let pp = products
  for (i = 0; i < pl; i++){
    let inType = pp[i]['income_type']
    let found = cfilter.filter(name => name.includes(inType))
    if (found.length){
      //alert('hello world')
      sum += pp[i][field] === "" ? 0 : incomeWeight(parseInt(pp[i][field]), pp[i]['income_frequency'])
    }
  }
  return sum
}
export const calcTotalExpensesByClass = (products, field, byClass) => {
  //console.log("calcTotalExpensesByClass", pl)
  if (products === undefined || products.length < 1) 
    return 0
  //console.log("calcTotalExpensesByClass", products)
  let cfilter = []
  switch (byClass){
    case "housing": cfilter = ["דיור"]; break;
    case "communication": cfilter = ["ניידים", "אינטרנט", "כבלים"]; break;
    
    default: 
      console.log("calcTotalExpensesByClass:  unexpected byClass value="+byClass)
      return -1
  } 
  let i = 0, sum=0
  for (i = 0; i < products.length; i++){
    let inType = products[i]['expense_category']
    let found = cfilter.filter(name => name.includes(inType))
    if (found.length){
      sum += products[i][field] === "" ? 0 : parseInt(products[i][field])
    }
  }
  return sum
}

export const calcTotalbyField = (products,field) => calcIncomeSum(products,field)

export const calcIncomeSum = (products,field) => {
  let i = 0, sum=0
  if (products === undefined || !products.length) return 0
  //console.log("calcIncome", products)
  for (i = 0; i < products.length; i++)
    sum += products[i][field] === "" || products[i][field] === "אחר" ? 0 : parseInt(products[i][field])
  return sum
}

export const missingFrequency = (products,field) => {
  let i = 0, sum=0
  if (products === undefined || !products.length) return 0
  //console.log("calcIncome", products)
  for (i = 0; i < products.length; i++)
    sum += products[i][field] === "" 
  return sum
}

export const SumTable = (props) => {
  return (<span className="table-total">
            <span className="table-total-title">{props.title}</span>
            <span className="table-sum">{calcIncomeSum(props.products, props.field).toLocaleString('he-IL')}</span>
            {props.frequency === undefined || !missingFrequency(props.products, props.frequency) ? null :
              <span className="warning-message">יש להגדיר תדירות לכל סכום בלשונית הכנסות </span>
            }
          </span>
          )
}

export const SumTable2 = (products, field, frequency, byClass, title) => {
    return( <span className="table-total">
                <span className="table-total-title">{title}</span>
                <span className="table-sum">{calcTotalIncomeByClass(products, field, byClass).toLocaleString('he-IL')}</span>
                {frequency === undefined || !missingFrequency(products, frequency) ? null :
                  <span className="warning-message">יש להגדיר תדירות לכל סכום בלשונית הכנסות</span>
                }
            </span>
          )
}

export const IncomeDetails = (products) => {
    return (
      <ul className="sub-sum">
        <li>
        {SumTable2(products,'income_sum', 'income_frequency', 'work', 'הכנסות מעבודה')}
        </li>
        <li>
        {SumTable2(products,'income_sum', 'income_frequency', 'rights', 'הכנסות מזכויות')

        //  <SumTable2 className="sub-sum" products={products} field={'income_sum'} frequency={'income_frequency'} byClass={"rights"} title={'הכנסות מזכויות'} />
    }
        </li>
        <li>
        {SumTable2(products,'income_sum', 'income_frequency', 'capital', 'הכנסות מהון')

         // <SumTable2 className="sub-sum" products={products} field={'income_sum'} frequency={'income_frequency'} byClass={"capital"} title={'הכנסות מהון'} />
  }
        </li>
      </ul>
    )
}
export const searchTableFilter = (line, filterText) => {
  if (filterText==="") 
    return true
  let found = 0
  Object.values(line).map( x => found += x.toString().indexOf(filterText) !== -1) 
  if (found === 0) 
    return false
  return true
}
            //    return null;
export const shlish = () => {
          let i = "nothing yet..."
   //       [1,2,3,4,5,6].map(x => i += " שליש" + x + "&#13;&#10;")
          ////console.log("shlish=", i)
          return i
}
           
export const digmaDate = (str) => {
  let parts = str.split(" ")
  let ms = "JanFebMarAprMayJunJulAugSepOctNovDec"
  let mon = ms.indexOf(parts[1])/3 +1
  let ret = parseInt(parts[2], 10) + "/" + mon + "/" + parseInt(parts[3], 10)
  return ret
}
//     onSaveSubTable(evt, data, dataId, dataType, cptId) {
// Generic call to update all ACF items group or table
export const saveSubAcf2DB = (cptId, data, dataId, dataType, inUpdate, mbouser) => {
  // var uri_ep = "http://yahav/wp-json/mbo/v3/updateFamily" 
  const uri_ep = UpdateFamilyEPmbo() 
  //this.setState({isPosting:true})
  inUpdate(true)
  let body ={
   //   "id": cptId, 
      "data": data,
      "dataId": dataId,
      "dataType": dataType,
      "id": cptId
  }
  // console.log("Utils: saveSubAcf2DB", body)
  fetch(uri_ep, {
      method: 'POST',
      headers: { 
        // 'Accept': 'application/json', 'Authorization': 'Basic '+btoa('meital:@site2goal.')
        'Accept': 'application/json', 'Authorization': 'Bearer' + mbouser.token
      },
      body: JSON.stringify({body}) 
  }).then(response => {
      if (response.ok) {
          // this.setState({isPosting:false})
          inUpdate(false)
          // alert("העדכונים נשמרו במאגר")
          // console.log("got ok from creating / updating terms table", response.json())
          return response.statusText // json()
      } else {
          inUpdate(false)
          throw new Error('Fetch error ' + cptId + " " + dataId + ' ... ', data)
      }
  }).catch(restError => {
    alert("תקלת תקשורת עם השרת - נא לרענן עמוד ולבצע כניסה מחדש "+ restError)
    console.log ("Utils, saveSubAcf2DB error", restError)
  })

}

export const createSnapshot = (cptId, phase, inUpdate, mbouser, cb) => {
  // var uri_ep = "http://yahav/wp-json/mbo/v3/createsnapshot" 
  const uri_ep = CreateSnapshotEPmbo()
  //this.setState({isPosting:true})
  inUpdate(true)
  let body ={
   //   "id": cptId, 
      "phase": phase,
      "id": cptId
  }
  //// console.log("Utils: createSnapshot", body)
  fetch(uri_ep, {
      method: 'POST',
      headers: { 
         // 'Accept': 'application/json', 'Authorization': 'Basic '+btoa('meital:@site2goal.')
         'Accept': 'application/json', 'Authorization': 'Bearer'+ mbouser.token
        },
      body: JSON.stringify({body}) 
  }).then(response => {
      if (response.ok) { // get the snapshot id
          // this.setState({isPosting:false})
          inUpdate(false)
          alert(".תמונת מצב נוצרה במאגר. יש לסגור את חלון המשפחה ולפתוח מחדש כדי לטעון אותה")
          //console.log("got ok from creating / updating terms table", response.json())
          return response.json()
      } else {
          inUpdate(false)
          throw new Error('Fetch error pid=' + cptId + " phase= " + phase)
      }
  }).then(data => {
    //console.log("createsnapshot=", data)
    cb(data) // update papa
  }).catch(restError => {
    alert("תקלת תקשורת עם השרת - נא לרענן עמוד ולבצע כניסה מחדש "+ restError)
    console.log ("Utils, createSnapshot error", restError)
  })
}

export const processQuery = (rules, cond, inUpdate, mbouser, cb, restErrCb) => {
  //const uri_ep = "https://yahav/wp-json/mbo/v3/processquery" 
  const uri_ep = ProcessQueryEPmbo()
  //this.setState({isPosting:true})
  inUpdate(true)
  let body ={
   //   "id": cptId, 
      "rules": rules,
      "cond": cond
  }
  //// console.log("Utils: processQuery", body)
  fetch(uri_ep, {
      method: 'POST',
      headers: { 
         'Accept': 'application/json', 'Authorization': 'Bearer' + mbouser.token
        },
      body: JSON.stringify({body}) 
  }).then(response => {
      if (response.ok) { // get the snapshot id
          // this.setState({isPosting:false})
          inUpdate(false)
          //if (rules !== 'init-tabs') 
          //  alert("השאילתה התבצעה")
          //console.log("got ok from creating / updating terms table", response.json())
          return response.json()
      } else {
          inUpdate(false)
          throw new Error('processQuery Fetch error rules=' + rules + " cond= " + cond)
      }
  }).then(data => {
    ////console.log("processQuery result=", data)
    cb(data === null ? [] : data) // update papa
  }).catch(restError => {
    restErrCb(restError)
    console.log ("Utils, processQuery error", restError)
  })
}

export const crudQuery = (crud, qid, qtitle, rules, cond, inUpdate, mbouser, cb, restErrCb) => {
  //const uri_ep = "https://yahav/wp-json/mbo/v3/crudquery" 
  const uri_ep = CrudQueryEPmbo()
  inUpdate(true)
  let body ={
    crud: crud, // Create, Read, Update, Delete
    qid: qid, // query (post) id
    qtitle: qtitle,
    rules: rules,
    cond: cond
  }
  //// console.log("Utils: crudQuery", body)
  fetch(uri_ep, {
      method: 'POST',
      headers: { 
         'Accept': 'application/json', 'Authorization': 'Bearer'+ mbouser.token
        },
      body: JSON.stringify({body}) 
  }).then(response => {
      if (response.ok) { // get the snapshot id
          inUpdate(false)
          //alert("הפעולה התבצעה")
          //console.log("crudQuery: got response.ok: ", response.json())
          return response.json()
      } else {
          inUpdate(false)
          throw new Error('crudQuery Fetch error rules=' + rules + " cond= " + cond)
      }
  }).then(data => {
    //console.log("crudQuery result=", data)
    cb(crud, data === null ? [] : data, qtitle, rules, cond) // update papa
  }).catch(restError => {
    restErrCb(restError)
    console.log ("Utils, crudQuery error", restError)
  })
}
export const Logo = () =>
  <div style={{ margin: '1rem auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center'}}>
    בשאלות ניתן לפנות {''}
  <br />
    <a rel="noopener noreferrer" href="https://site2goal.co.il" target="_blank">
      <img alt="Site@goal לקידום עסקים באינטרנט"
        src="https://site2goal.co.il/wp-content/uploads/2017/10/site2goal_logo_webVERp.png"
        style={{ width: `150px`, height: "auto", margin: ".5em auto .3em" }}
      />
    </a>
  </div>

export const Tips = () =>
  <div style={{ textAlign: "center" }}>
    <em>טיפ: למיון מרובה עמודות יש ללחוץ על כפתור SHIFT!</em>
  </div>

export const MboTips = (msg) =>
  <div style={{ textAlign: "center" }}>
    <em>{msg}</em>
  </div>

export function updateElement(evt, products){
  var item = {
    id: evt.target.id,
    name: evt.target.name,
    value: evt.target.value
  }
  var newp = Object.assign(products)
  for (var key in newp) {
    if (key === item.name) {
        newp[key] = item.value
    }
  }
  return newp
}

export const empty_family_products_services= {
  q1: "",
  q101: "",
  q102: "",
  q103: "",
  q104: "",
  q105: "",
  q106: "",
  q107: "",
  q108: "",
  q109: "",
  q110: "",
  q201: "",
  q202: "",
  q203: "",
  q204: "",
  q205: "",
  q206: "",
  q207: "",
  q208: "",
  q209: "",
  q210: "",
  q211: "",
  q212: "",
  q213: "",
  q214: "",
  q215: "",
  q31: "",
  q32: "",
  q33: "",
  q401: "",
  q402: "",
  q403: "",
  q404: "",
  q405: "",
  q406: "",
  q407: "",
  q408: "",
  q409: "",
  q410: "",
  q411: "",
  q412: "",
  q413: "",
  comments: ""
}
